import * as React from "react";
import { Grid, Typography } from '@material-ui/core';

// tslint:disable-next-line:no-empty-interface
export interface IProductsContainerState {}

// tslint:disable-next-line:no-empty-interface
export interface IProductsContainerProps {
    products: JSX.Element[];
    itensLine: number;
}

export class ProductsContainer extends React.Component<IProductsContainerProps, IProductsContainerState> {
    constructor(props: IProductsContainerProps) {
        super(props);
    }
    
    public render() {
        return (
        <Grid container={true} className="publisher-sale-panel panel-grid panel-bg-area" spacing={24}>
            <Grid item={true} xs={12} className="panel-bg" >
                <Typography component="h3" className="panel-head">
                    Produtos
                </Typography>
                <Grid container={true} justify="center">
                        {
                        this.props.products.map( (item) => (
                        <Grid item={true} sm={2} className="modal" key={item.key+ ''}>
                            {item}
                        </Grid>
                        ) )
                    }
                </Grid>
            </Grid>
        </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/component/shared/layout/products/ProductsContainer.tsx